// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ktjO","modalFooterButton":"ModalNotes_modalFooterButton__1HzUc"};